import styles from './LiveSessionEntryButton.module.css';
import type { UseStrategistLiveEntryResult } from '../hooks/useStrategistLiveEntry';

type Props = {
  entry: UseStrategistLiveEntryResult;
  className?: string;
};

/** Top-bar / lobby CTA for strategists (Start or Join Live Session). */
export default function LiveSessionEntryButton({ entry, className }: Props) {
  if (entry.mode === 'hidden') return null;

  return (
    <div className={`${styles.wrap} ${className ?? ''}`.trim()}>
      <button
        type="button"
        className={styles.btn}
        onClick={() => void entry.run()}
        disabled={entry.busy || entry.sessionsLoading}
        title={entry.mode === 'start' ? 'Create an open live session' : 'Open the latest live session'}
      >
        {entry.busy ? 'Working…' : entry.label}
      </button>
      {entry.error && (
        <span className={styles.error} role="alert">
          {entry.error}
        </span>
      )}
    </div>
  );
}
